export interface InpiDepositDeclarationBeneficiaryJson {
  id?: number;
  street?: string;
  postal_code?: string;
  city?: string;
  insee_code?: string;
}

export class InpiDepositDeclarationBeneficiary {
  constructor(
    public id?: number,
    public siret?: string,
    public postalCode?: string,
    public city?: string,
    public inseeCode?: string
  ) {}

  static toJson(inpiDeposit: InpiDepositDeclarationBeneficiary): InpiDepositDeclarationBeneficiaryJson {
    return {
      id: inpiDeposit.id,
      street: inpiDeposit.siret,
      postal_code: inpiDeposit.postalCode,
      city: inpiDeposit.city,
      insee_code: inpiDeposit.inseeCode
    };
  }
}
